module.exports = __webpack_public_path__ + "img/五星特级大师@3x.b857198e.png";